<app-shared-layout
  Analysis="Sensor Bin Coverage"
  [hideAdd]="true"
  animationSize="full"
  [secondaryWithStyle]="false"
>
  <div ngProjectAs="primary-panel" class="relative h-100vh">
    <div class="h-100vh !px-3 pt-3 pb-6 overflow-y-scroll">
      <app-loader @fadeIn *ngIf="isLoading"></app-loader>

      <div class="flex items-center justify-center mb-4">
        <div
          class="bg-grey/40 shadow font-medium text-primary px-3 py-2 rounded-full border"
        >
          {{ selectedSensorBinCoverage[0]?.serialNumber }}
        </div>
      </div>
      <div class="flex justify-center my-2">
        <div class="flex rounded-lg border gap-4 items-center px-4">
          <button
            class="px-4 py-1 text-primary"
            (click)="fetchPage(pagination, 'prev')"
          >
            Prev
          </button>
          <select
            class="px-4 py-1 text-primary bg-transparent"
            [ngModel]="pagination?.currentPageNumber"
            (change)="fetchPage(pagination, $event)"
          >
            @for (page of pagination?.pagesNumberArray; track $index) {
              <option [value]="page">{{ page }}</option>
            }
          </select>
          <button
            class="px-4 py-1 text-primary"
            (click)="fetchPage(pagination, 'next')"
          >
            Next
          </button>
        </div>
      </div>
      <mat-accordion multi>
        <mat-expansion-panel
          @fadeIn
          *ngFor="let grouped of allZonesNew; let idx = index"
          [expanded]="true"
        >
          <mat-expansion-panel-header
            class="bg-primary-50/40 border-b border-primary"
          >
            <mat-panel-title class="flex justify-between !text-primary">
              {{ idx + 1 }}. {{ grouped.name }}
            </mat-panel-title>
          </mat-expansion-panel-header>
        <div class="flex flex-wrap items-center gap-3 mb-4 
            bg-gray-50 border rounded-xl px-4 py-3 shadow-sm">

  <span class="text-sm text-gray-500">Quick Select Range:</span>

  <input 
    type="text"
    [(ngModel)]="binRangeInput"
    placeholder="e.g., A2AA24A - A2AA26A"
    class="w-60 px-3 py-1 border rounded-lg focus:ring-2 focus:ring-primary/40 outline-none"
  />

  <button
    (click)="selectBinsByFullRange(grouped)"
    class="bg-primary text-white px-4 py-1 rounded-lg shadow hover:scale-105 transition"
  >
    Select / Unselect Range
  </button>

</div>
          <div class="grid grid-cols-12">
            <div
              class="col-span-12 md:col-span-4"
              *ngFor="let bin of grouped.bins; let i = index"
            >
              <mat-checkbox
                (change)="onChange(bin.uniqueId, $event, grouped.bins, i)"
                [checked]="hasBin(bin.uniqueId)"
                [value]="bin.uniqueId"
                [title]="bin.binNumber"
                color="primary"
              >
                {{ bin.binNumber }}
              </mat-checkbox>
            </div>
         <div
  (click)="selectAllGrouped(grouped)"
  class="text-sm col-span-12 flex w-[95%] justify-end cursor-pointer m-5 text-primary"
>
  {{ getSelectAllText(grouped) }}
</div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="bottom-16 right-16 fixed flex items-end justify-end">
      <button
        (click)="saveChanges()"
        mat-fab
        [disabled]="!formChanged"
        color="primary"
        class="absolute top-0 right-0"
      >
        <mat-icon style="color: white">save</mat-icon>
      </button>
    </div>
  </div>
</app-shared-layout>
